import { render, staticRenderFns } from "./SetCategory.vue?vue&type=template&id=12ae6492&scoped=true"
import script from "./SetCategory.vue?vue&type=script&lang=js"
export * from "./SetCategory.vue?vue&type=script&lang=js"
import style0 from "./SetCategory.vue?vue&type=style&index=0&id=12ae6492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae6492",
  null
  
)

export default component.exports